import { Component, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { RegistrierungService } from '../../services/registrierung.service';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, switchMap } from 'rxjs/operators';
import { RegistrierungComponent } from '../registrierung.component';
import { VertragszustimmungMTO } from '../../generated-model/vertragszustimmungMTO';
import { MatCheckbox } from '@angular/material/checkbox';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-agb',
  imports: [FormsModule, ReactiveFormsModule, MatCheckbox, TranslatePipe],
  templateUrl: './agb.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './agb.component.scss',
})
export class AgbComponent {
  private readonly registrierungService = inject(RegistrierungService);
  registrierungComponent = inject(RegistrierungComponent);

  // Signal inputs
  formGroupAGB = input<FormGroup>({} as FormGroup);
  typ = input<'mitarbeiter' | 'pruefer'>('mitarbeiter');

  constructor() {
    // Setup auto-save effect on form value changes
    effect(() => {
      const fg = this.formGroupAGB();
      if (fg?.valueChanges) {
        fg.valueChanges
          .pipe(
            debounceTime(200),
            switchMap((value) => {
              return this.updateAGB(value);
            })
          )
          .subscribe((result) => {
            if (result === false) {
              console.log('formular failure: autosave not executed');
            }
          });
      }
    });
  }

  private updateAGB(value: any) {
    const { einverstanden_agb } = value;
    const vertragzustimmung: VertragszustimmungMTO = {} as VertragszustimmungMTO;
    vertragzustimmung.vertragsbestimmungen = einverstanden_agb;
    vertragzustimmung.vertragsabschluss = einverstanden_agb;
    this.registrierungService.registrierungsdaten.vertragszustimmung = vertragzustimmung;
    this.setzeValidierStatus();
    return this.registrierungService.saveRegistrierungsdatenToLocalStorage();
  }

  isEinverstandenVertrag(): boolean {
    return this.formGroupAGB().get('einverstanden_agb')?.value === true;
  }

  private setzeValidierStatus() {
    this.registrierungComponent.abschlussRegistrierungOK.set(this.isEinverstandenVertrag());
  }
}
